import { Residence } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { MarketCountryCode } from '@axo/shared/types';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';

const unfilteredHousingTypeOptions = (
  [
    { value: null },
    {
      value: Residence.OwnApartment,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Finland,
            MarketCountryCode.Norway,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: Residence.OwnHouse,
    },
    {
      value: Residence.CooperativeApartment,
      whitelist: [
        {
          marketCountry: [
            MarketCountryCode.Sweden,
            MarketCountryCode.Norway,
            MarketCountryCode.Denmark,
          ],
        },
      ],
    },
    {
      value: Residence.Rental,
    },
    {
      value: Residence.Tenant,
      whitelist: [{ marketCountry: [MarketCountryCode.Sweden] }],
    },
    {
      value: Residence.PartnersHouse,
      whitelist: [{ marketCountry: [MarketCountryCode.Finland] }],
    },
    {
      value: Residence.CompanyOwnedFlat,
      whitelist: [{ marketCountry: [MarketCountryCode.Finland] }],
    },
    {
      value: Residence.Cohabitant,
      whitelist: [{ marketCountry: [MarketCountryCode.Finland] }],
    },
    {
      value: Residence.WithParents,
      whitelist: [
        {
          marketCountry: [MarketCountryCode.Finland],
          broker: [Broker.Zmarta],
        },
      ],
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    Residence | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useHousingTypeOptions = () =>
  useApplicationConditionalFilter(unfilteredHousingTypeOptions);
